<template>
  <div class="socials">
    <h5 class="socials__title">{{ title }} {{ availableSocials }}</h5>
    <socials-loader v-if="!isComponentReady"></socials-loader>
    <div class="socials__items" v-else>
      <div class="socials__item" v-if="facebookLink">
        <a
          @click="registrationTrack('Facebook')"
          :href="facebookLink"
          class="socials__button socials__button--facebook"
        >
        </a>
      </div>
      <div class="socials__item" v-if="googleLink">
        <a
          @click="registrationTrack('Google')"
          :href="googleLink"
          class="socials__button socials__button--google"
        >
        </a>
      </div>
      <div class="socials__item" v-if="twitterLink">
        <a
          @click="registrationTrack('Twitter')"
          :href="twitterLink"
          class="socials__button socials__button--twitter"
        >
        </a>
      </div>
    </div>
    <div class="socials__line">
      <div class="socials__line-border"></div>
      <div class="socials__line-label">OR</div>
      <div class="socials__line-border"></div>
    </div>
  </div>
</template>

<script src="./socials.js"></script>
<style src="./socials.scss" lang="scss"></style>
